import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { cancelInfo, cancelPolicy } from './request';
export default {
  data() {
    return {
      dataFrom: {
        people: []
      },
      visible: false,
      customerId: '',
      policyId: ''
    };
  },
  computed: {
    rules() {
      return {
        people: [{
          required: true,
          message: this.$t('请选择') + this.$t('退单的被保险人姓名')
        }]
      };
    }
  },
  methods: {
    async init(customerId, policyId) {
      this.customerId = customerId;
      this.policyId = policyId;
      const res = await cancelInfo({
        customerId,
        policyId
      });
      this.dataFrom = res;
      this.visible = true;
    },
    changeAttach(value) {
      if (value.length) {
        if (value.includes('all')) {
          this.dataFrom.people = ['all'];
          this.dataFrom.insured.forEach((item, i) => {
            this.dataFrom.insured[i].disabled = true;
          });
          this.dataFrom.paymentAmount = this.dataFrom.price * this.dataFrom.insured.length;
        } else {
          this.dataFrom.insured.forEach((item, i) => {
            this.dataFrom.insured[i].disabled = false;
          });
          this.dataFrom.paymentAmount = this.dataFrom.price * value.length;
        }
      } else {
        this.dataFrom.insured.forEach((item, i) => {
          this.dataFrom.insured[i].disabled = false;
        });
        this.dataFrom.paymentAmount = '';
      }
    },
    close() {
      this.visible = false;
      this.$emit('cancel');
      this.form.people = [];
    },
    async confirm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          let obj = {};
          obj.customerId = this.customerId;
          obj.policyId = this.policyId;
          obj.personnelType = this.dataFrom.people.includes('all') ? 'ALL' : 'PART';
          if (this.dataFrom.people.includes('all')) {
            obj.cancelPersonnel = this.dataFrom.insured.map(item => {
              let obj = {
                insuredName: item.insuredName,
                insuredIdNo: item.insuredIdNo
              };
              return obj;
            });
          } else {
            obj.cancelPersonnel = this.dataFrom.insured.filter(item => {
              if (this.dataFrom.people.includes(item.insuredIdNo)) {
                let obj = {
                  insuredName: item.insuredName,
                  insuredIdNo: item.insuredIdNo
                };
                return obj;
              }
            });
          }
          // console.log(obj, this.dataFrom.insured);
          await cancelPolicy(obj);
          this.$message.success(this.$t('操作成功'));
          this.$emit('confirm');
        }
      });
    }
  }
};